import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const quoteStatusVersionsAdapter = getAdapter({ idFieldName: 'value' });

const quoteStatusVersionsSlice = createSlice({
  name: 'quoteStatusVersions',
  initialState: quoteStatusVersionsAdapter.getInitialState(),
  reducers: {
    setQuoteStatusVersions: (state, { payload: { quoteStatusVersions } }) => {
      quoteStatusVersionsAdapter.setAll(state, quoteStatusVersions);
    },
  },
});

const selectors = quoteStatusVersionsAdapter.getSelectors(({ quoteStatusVersions }) => quoteStatusVersions);

export const getQuoteStatusVersions = (state) => selectors.selectAll(state);

export const {
  setQuoteStatusVersions,
} = quoteStatusVersionsSlice.actions;

export default quoteStatusVersionsSlice.reducer;
